import React, { useState, memo } from "react";
import { Button } from "@mui/material";
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import {Loading} from "../../../components";

const MarketerOperationSalesExport = ({ marketer, entities }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("OperationSales");


            worksheet.columns = [
                { header: "تاریخ", key: "date", width: 25 },
                { header: "تعداد فاکتور", key: "total_count", width: 20 },
                { header: "مبلغ", key: "total_pay", width: 20 },
            ];


            entities.forEach((item) => {
                const date = moment(item.label, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD');
                worksheet.addRow({
                    date,
                    total_count: item.total_count ?? 0,
                    total_pay: item.total_pay ?? 0
                });
            });


            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 14 };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCEEFF' } };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });


            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 12 };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    });
                }
            });


            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `marketer_operation_sales_${marketer}_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting operation sales:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={fetchData}
                disabled={loading}
            >
                خروجی میزان فروش
            </Button>
            {loading && <Loading />}
        </>
    );
};

export default memo(MarketerOperationSalesExport);
